import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../config/web-config";

const RequestQuotationIframe = () => {
  // Here id is Company ID
  const { id } = useParams();
  const [iframeUrl, setIframeUrl] = useState("");
  const [error, setError] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    // QR: Quoatation Request
    const url = `https://${window.location.host}/quotation/create/${id}/QR`;
    setIframeUrl(url);
  }, [id]);

  const handleIframeLoad = () => {
    console.log("Iframe loaded successfully");
    setIframeLoaded(true);
  };

  const handleIframeError = () => {
    console.error("Iframe failed to load");
    setError("Failed to load the quotation form. Please try again later.");
  };

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="inline-flex items-center justify-start flex-col w-full py-5 gap-y-5">
      <h2 className="font-monaSansSemiBold text-center text-xl mb-3">
        Request Quotation
      </h2>
      {!iframeLoaded && <div>Loading...</div>}
      {iframeUrl && (
        <div className="iframe-container w-11/12">
          <iframe
            src={iframeUrl}
            onload="this.style.height=(this.contentDocument.body.scrollHeight+45) +'px';"
            id="iframe"
            className="w-full"
            style={{
              minHeight: "600px",
              margin: "auto",
              display: iframeLoaded ? "block" : "none",
            }}
            title="Request Quotation Form"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        </div>
      )}
    </div>
  );
};

export default RequestQuotationIframe;
